import { useCallback } from 'react';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useProgramHistoryPageRedirect = () => {
  const { doRedirectWithSavePageUrl, ...rest } = usePagesRedirect('useProgramHistoryPageRedirect');
  const { code } = useModuleByCodeParam();

  const redirectToHistoryPage = useCallback(() => {
    doRedirectWithSavePageUrl(`/programs/${code}/history`);
  }, [doRedirectWithSavePageUrl, code]);

  return { ...rest, redirectToHistoryPage };
};
